export const formatNumber = (number: number, options?: Intl.NumberFormatOptions) => {
  return new Intl.NumberFormat('en-EI', {
    style: "currency",
    currency: 'EUR',
    maximumFractionDigits: 0,
    ...options
  }).format(number);
}
